import React from 'react';
import { Provider } from "react-redux";
import reportWebVitals from './reportWebVitals';
import ptBr from "antd/lib/locale/pt_BR";
import { ConfigProvider } from "antd";
import configureStore from "store";
import { MainRoutes } from "config/routes/main-routes";
import { setupInterceptors } from "config/service/http-service";
import { setupBreakageInterceptors } from "config/service/breakage-http-service";
import { initLanguage } from 'config/language'
import { themeColors, themeText, themeLayout } from 'theme';
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';
import { isBcerto } from 'utils';
import bcertoFavicon from 'assets/img/b_certo_tab.svg';
import 'styles/style.scss'
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container);
const store = configureStore();
setupInterceptors(store);
setupBreakageInterceptors();

document.title = isBcerto ? 'B Certo' : 'Aly+';
const favicon = document.getElementById('favicon');
if (isBcerto && favicon) {
  favicon.rel = 'icon';
  favicon.href = bcertoFavicon;
}

initLanguage();

root.render(
  <Provider store={store}>
    <StyleProvider hashPriority='high' transformers={[legacyLogicalPropertiesTransformer]}>
      <ConfigProvider locale={ptBr} theme={{
        token: {
          colorPrimary: themeColors.mediumColor,
          colorLink: themeColors.blueColor,
          colorInfo: themeColors.blueColor,
          colorSuccess: themeColors.successColor,
          colorWarning: themeColors.warningColor,
          colorError: themeColors.errorColor,
          colorBgContainerDisabled: themeColors.disabledColor,
          colorTextDisabled: themeColors.disabledTextColor,
          borderRadius: themeLayout.borderRadius,
          boxShadow: themeLayout.boxShadow,
          fontFamily: themeText.fontFamily,
          colorText: themeColors.mediumColor,
        },
        components: {
          Card: {
            colorBgContainer: themeColors.softColor,
          },
          Button: {
            boxShadow: 'none !important',

          },
          Layout: {
            colorBgBase: 'red',
            colorBgContainer: 'red',
            headerBg: '#fff',
            bodyBg: '#fff',
          },
          Menu: {
            itemBg: themeColors.softColor,
            itemColor: themeColors.mediumColor,
            itemHoverColor: themeColors.mediumColor,
            itemSelectedColor: '#fff',
            itemActiveBg: 'red',
            itemHoverBg: themeColors.softColor,
            colorBgTextActive: '#fff',
            colorBgTextHover: themeColors.mediumColor,
            darkItemColor: themeColors.mediumColor,
            darkItemHoverColor: themeColors.mediumColor,
            motion: false
          },
          Table: {
            colorTextHeading: '#fff'
          }
        }
      }}>

        <div style={{ ["--sheet-text-color"]: isBcerto ? "#002F1A" : "black" }}>
          <MainRoutes />
        </div>
      </ConfigProvider>
    </StyleProvider>
  </Provider >,
);

reportWebVitals();
